function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import moment from "moment";
import "jquery";
/**
 * 入力検証
 */

var Validations = /*#__PURE__*/function () {
  function Validations() {
    _classCallCheck(this, Validations);
  }

  _createClass(Validations, [{
    key: "validationOptions",

    /**
     * バリデーションオプション
     */
    value: function validationOptions() {
      return {
        highlight: function highlight(element, _errorClass, _validClass) {
          $(element).addClass('is-invalid');
        },
        unhighlight: function unhighlight(element, _errorClass, _validClass) {
          $(element).removeClass('is-invalid');
        },
        ignore: "",
        onsubmit: false,
        debug: true
      };
    }
  }, {
    key: "nowhitespace",

    /**
     * WhiteSpaceではないことを検証します。
     *
     * @param value 値
     */
    value: function nowhitespace(value) {
      if (value == null || value.trim().length == 0) {
        return false;
      }

      return true;
    }
    /**
     * 日時フォーマットであることを検証します。
     *
     * @param value 値
     * @param element エレメント
     */

  }, {
    key: "datetime",
    value: function datetime(value, element) {
      if (value == "") {
        return true;
      }

      var format = $(element).data("valDatetimeFormat");
      return moment(value, format, true).isValid();
    }
    /**
     * 数値（カンマを考慮）であることを検証します。
     *
     * @param value 値
     * @param element エレメント
     * @param _params パラメータ
     */

  }, {
    key: "decimalnumber",
    value: function decimalnumber(value) {
      if (value == "") {
        return true;
      }

      return /^[-]?\d*(\.\d+)?$/.test(value.replace(",", ""));
    }
  }]);

  return Validations;
}();

export { Validations as default };